// ==================================================
//  MTS Simple Booking
// ==================================================
$(function() {
  // disable対応（複合カレンダーのみ使用）
  $('.bookingCalendar table td').each(function() {
    if (!$(this).is(":contains('◯')") && !$(this).is(":contains('△')")) {
      $(this).addClass('disable');
    }
  });

  // ラジオボタン
  $('input[type="radio"]').on('change',function() {
    console.log('Chenge Radio!');
    $(this).parents('td').find('label').removeClass('checked');
    $(this).parents('label').addClass('checked');
  });

  // Placeholder
  $('input[name="booking[client][sei]"]').attr('placeholder', '田中');
  $('input[name="booking[client][sei_kana]"]').attr('placeholder', 'タナカ');
  $('input[name="booking[client][mei]"]').attr('placeholder', '太郎');
  $('input[name="booking[client][mei_kana]"]').attr('placeholder', 'タロウ');
  $('input[name="booking[client][tel]"]').attr('placeholder', '000-000-0000');
  $('input[name="booking[client][email]"]').attr('placeholder', 'reserve@sanmeigaku-meiren.com');
  $('input[name="booking[client][postcode]"]').attr('placeholder', '000-0000');
  $('input[name="booking[client][address1]"]').attr('placeholder', '都道府県');
  $('input[name="booking[client][address2]"]').attr('placeholder', '市区町村');
  $('textarea[name="booking[note]"]').attr('placeholder', '鑑定を依頼する内容などを詳細にご記入ください。');
});